import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import ImageUpload from './ImageUpload';

const CATEGORIES = ['Kuliner', 'Fashion', 'Jasa', 'Elektronik', 'Pertanian', 'Kerajinan', 'Properti', 'Lainnya'];
const inputCls = 'w-full px-4 py-3 rounded-xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none font-body text-sm';

export const UMKM_EMPTY = { name: '', description: '', category: '', location: '', whatsapp: '', video_url: '', images: [], logo_url: '' };

const UMKMForm = ({ open, formData, setFormData, onSubmit, onClose, editing }) => {
  if (!open) return null;
  const setImage = (i, url) => {
    const imgs = [...(formData.images || [])];
    imgs[i] = url || '';
    setFormData({ ...formData, images: imgs });
  };
  const submit = (e) => {
    e.preventDefault();
    const images = (formData.images || []).filter(Boolean).slice(0, 3);
    onSubmit({ ...formData, images, logo_url: images[0] || formData.logo_url || '' });
  };
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}
          className="bg-white rounded-3xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
          <div className="sticky top-0 bg-white border-b border-stone-200 px-6 py-4 flex items-center justify-between z-10">
            <h3 className="text-xl font-heading font-bold text-primary-dark">{editing ? 'Edit Iklan' : 'Pasang Iklan Baru'}</h3>
            <button onClick={onClose} className="p-2 hover:bg-stone-100 rounded-full"><X className="w-5 h-5" /></button>
          </div>
          <form onSubmit={submit} className="p-6 space-y-4" data-testid="umkm-form">
            <input data-testid="umkm-name-input" className={inputCls} placeholder="Judul / Nama Usaha *" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
            <div className="grid grid-cols-2 gap-3">
              <select data-testid="umkm-category-input" className={inputCls} value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} required>
                <option value="">Pilih Kategori *</option>
                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
              <input data-testid="umkm-location-input" className={inputCls} placeholder="Lokasi (mis. Batam Kota)" value={formData.location || ''} onChange={(e) => setFormData({ ...formData, location: e.target.value })} />
            </div>
            <textarea data-testid="umkm-description-input" className={inputCls} rows={3} placeholder="Deskripsi produk/jasa *" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} required />
            <input data-testid="umkm-whatsapp-input" className={inputCls} placeholder="Nomor WhatsApp (628xxx) *" value={formData.whatsapp} onChange={(e) => setFormData({ ...formData, whatsapp: e.target.value })} required />
            <input data-testid="umkm-video-input" className={inputCls} placeholder="Link Video YouTube / Instagram (opsional)" value={formData.video_url || ''} onChange={(e) => setFormData({ ...formData, video_url: e.target.value })} />
            <div>
              <label className="block text-sm font-body font-medium text-text-primary mb-2">Foto Produk (maks 3, foto pertama jadi sampul)</label>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {[0, 1, 2].map((i) => (
                  <ImageUpload key={i} value={(formData.images || [])[i] || ''} onChange={(url) => setImage(i, url)} label={`Foto ${i + 1}`} />
                ))}
              </div>
            </div>
            <div className="flex gap-3 pt-2">
              <button type="button" onClick={onClose} className="flex-1 px-6 py-3 bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-full font-body font-medium">Batal</button>
              <button type="submit" data-testid="umkm-submit-btn" className="flex-1 px-6 py-3 bg-emerald-700 hover:bg-emerald-800 text-white rounded-full font-body font-medium">{editing ? 'Update' : 'Simpan'}</button>
            </div>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default UMKMForm;
